import { JSX } from "react";
import { Button, Popup } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    title: string;
    text: string;
    onCloseClick: () => void;
    onCloseButtonText: string;
    onConfirmationClick: () => void;
    onConfirmationButtonText: string;
    onConfirmationButtonIsLoading?: boolean;
}

export const DeleteConfirmationModalContainer = (props: Props): JSX.Element => {
    const {
        title,
        onCloseClick,
        onConfirmationClick,
        onConfirmationButtonText,
        onCloseButtonText,
        text,
        onConfirmationButtonIsLoading,
    } = props;

    return (
        <Popup
            className={"c-delete-confirmation-modal"}
            title={title}
            onCloseClick={onCloseClick}
        >
            <p className={"c-delete-confirmation-modal__text"}>{text}</p>
            <div className={"c-delete-confirmation-modal__buttons"}>
                <Button
                    variant={"alert"}
                    onClick={onConfirmationClick}
                    loading={onConfirmationButtonIsLoading}
                >
                    {onConfirmationButtonText}
                </Button>
                <Button variant={"tertiary"} onClick={onCloseClick}>
                    {onCloseButtonText}
                </Button>
            </div>
        </Popup>
    );
};
